export const searchList = [
  {
    id: "searchList1",
    musicImg:
      "https://dongsooo.github.io/imgs/img/09_chill-01_Lofi chill Beats - Chill Everyday.jpeg",
    musicTitle: "Chill Everyday",
    musicSInger: "Lofi chill Beats",
  },
  {
    id: "searchList2",
    musicImg:
      "https://dongsooo.github.io/imgs/img/09_chill-02_Xander - Sleepwalking.jpg",
    musicTitle: "Sleepwalking",
    musicSInger: "Xander",
  },
  {
    id: "searchList3",
    musicImg:
      "https://dongsooo.github.io/imgs/img/09_chill-03_Lakey Inspired - Chill day.jpg",
    musicTitle: "Chill day",
    musicSInger: "Lakey Inspired",
  },

  {
    id: "searchList4",
    musicImg:
      "https://dongsooo.github.io/imgs/img/09_chill-05_Charmer - Seney Stretch.jpg",
    musicTitle: "Seney Stretch",
    musicSInger: "Charmer",
  },
  {
    id: "searchList5",
    musicImg:
      "https://dongsooo.github.io/imgs/img/09_chill-06_Lucky tapes Dressing.jpg",
    musicTitle: "Lucky tapes Dressing",
    musicSInger: "Lucky tapes Dressing",
  },
  {
    id: "searchList6",
    musicImg:
      "https://dongsooo.github.io/imgs/img/09_chill-07_Night tapes - Drifting.png",
    musicTitle: "Drifting",
    musicSInger: "Night tapes",
  },
  {
    id: "searchList7",
    musicImg:
      "https://dongsooo.github.io/imgs/img/09_chill-08_Kina - Nobody cares.jpg",
    musicTitle: "Nobody cares",
    musicSInger: "Kina",
  },
  {
    id: "searchList8",
    musicImg:
      "https://dongsooo.github.io/imgs/img/09_chill-09_Mikel Poke & Chill.jpg",
    musicTitle: "Poke & Chill",
    musicSInger: "Mikel",
  },
  {
    id: "searchList9",
    musicImg:
      "https://dongsooo.github.io/imgs/img/09_chill-10_Origami Angel - Somewhere City.jpg",
    musicTitle: "Somewhere City",
    musicSInger: "Origami Angel",
  },
  {
    id: "searchList10",
    musicImg:
      "https://dongsooo.github.io/imgs/img/09_chill-11_Yashi and Youmg Moth - Float.png",
    musicTitle: "Float",
    musicSInger: "Yashi and Youmg Moth",
  },
];
